export default "__VITE_ASSET__Qy77eDAc__"